import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import moment from "moment";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const formatToYMD = (dateStr: string) => {
  if (!dateStr) return null;
  return moment(dateStr).format("YYYY-MM-DD");
};
